<template>
  <div class="brand">
    <div class="brand-top">
      <img src="../../assets/cake/brand.png">
    </div>
    <brands :list="brandList" @select="handleSelect"></brands>
  </div>
</template>
<script>
import { brands } from './componets';
export default {
  components: {
    brands
  },
  data () {
    return {
      brandList: []
    }
  },
  methods: {
    getBrandList () {
      for (let i = 0; i < 30; i++) {
        this.brandList = [
          {
          cat_id: 0,
          cat_name: '奈雪的茶',
          cat_pic: require('@/assets/cake/brand/01.png')
          },
          {
            cat_id: 1,
            cat_name: '星巴克',
            cat_pic: require('@/assets/cake/brand/02.png')
          },
          {
            cat_id: 2,
            cat_name: '幸福西饼',
            cat_pic: require('@/assets/cake/brand/03.png')
          },
          {
            cat_id: 3,
            cat_name: '幸福西饼',
            cat_pic: require('@/assets/cake/brand/04.png')
          },
          {
            cat_id: 7,
            cat_name: '哈根达斯',
            cat_pic: require('@/assets/cake/brand/07.png')
          },
          {
            cat_id: 8,
            cat_name: 'DQ皇后',
            cat_pic: require('@/assets/cake/brand/08.png')
          },
          {
            cat_id: 9,
            cat_name: '爱心品',
            cat_pic: require('@/assets/cake/brand/09.jpg')
          },
            {
            cat_id: 10,
            cat_name: '好利来',
            cat_pic: require('@/assets/cake/brand/10.jpg')
          },
        ]
      }
    },
    handleSelect (item) {
      this.$router.push({
        name: 'CakeBrandDetail',
        query: {
          bId: item.id
        }
      })
    }
  },
  mounted() {
    this.getBrandList();
  },
}
</script>
<style lang="scss" scoped>
  .brand {
    min-height: 100vh;
    background: #fff;
    .brand-top{
      width: 100%;
      height: 2.82rem;
    }
  }
</style>